import api from "@/api";

const SET_MEGA_MENU = "SET_MEGA_MENU";
const SET_FOOTER_MENU = "SET_FOOTER_MENU";

export default {
  namespaced: true,
  state: {
    mega: [],
    footer: [],
  },
  getters: {
    megaMenu: ({ mega }) => mega,
    footerMenu: ({ footer }) => footer,
  },
  actions: {
    async getMegaMenu({ commit }) {
      let res = await api.menu.mega();
      commit(SET_MEGA_MENU, res.data["hydra:member"] || []);
      return res;
    },
    async getFooterMenu({ commit }) {
      let res = await api.menu.footer();
      commit(SET_FOOTER_MENU, res.data["hydra:member"] || []);

      return res;
    },
  },
  mutations: {
    [SET_MEGA_MENU](state, menu) {
      state.mega = menu;
    },
    [SET_FOOTER_MENU](state, menu) {
      state.footer = menu;
    },
  },
};
